module.exports = __webpack_public_path__ + "assets/records-thin.215d0edf.svg";